import React from 'react';
import anchorme from 'anchorme';
import { ISubtextBlockPreviewProps } from './ISubtextBlockPreviewProps';
import BlockContainer from '../BlockComponents/BlockContainer';
import BlockContentContainer from '../BlockComponents/BlockContentContainer';
import BlockTextContainer from '../BlockComponents/BlockTextContainer';

const SubtextBlockPreview: React.FC<ISubtextBlockPreviewProps> = (props) => {

  return (
    <BlockContainer
    design={props.blockData.design}
    >
        <BlockContentContainer
        className={`${props.view ? props.view : ''}`}
        design={props.blockData.design}
        >
          <BlockTextContainer
          design={props.blockData.design}
          pageStyles={props.pageStyles}
          textKey="subtext"
          fallbackTextColor="#666666"
          dangerouslySetInnerHTML={{
              __html: anchorme(props.blockData.text),
          }}
          />
        </BlockContentContainer>
    </BlockContainer>
  )
}

export default SubtextBlockPreview;